import { useState } from 'react';
import DebouncedInput from '../DebouncedInput';
import { TariffSuggestions } from './TariffSuggestions';
import { P2GBox, P2GText } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  selectCode: (code: string) => void;
  searchTerm?: string;
  tariffSystem: string;
  canSelect: boolean;
}

const TariffSuggestionSearch: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const [searchTerm, setSearchTerm] = useState(props.searchTerm || '');

  return (
    <P2GBox>
      <P2GBox mb={2}>
        <DebouncedInput
          label={t('SEARCH_INPUT_LABEL', { defaultValue: 'Search' })}
          id="Search"
          value={searchTerm}
          onChange={setSearchTerm}
        />
      </P2GBox>
      <TariffSuggestions
        limit={10}
        showLoader
        selectCode={props.selectCode}
        tariffSystem={props.tariffSystem}
        itemDescription={searchTerm}
        canSelect={props.canSelect}
        showAllOnLoad
        noResultsMessage={<P2GText variant="body2">No results found</P2GText>}
      />
    </P2GBox>
  );
};

export { TariffSuggestionSearch };
